<template>
    <div class="container mt-4">
      <b-row v-if="CartHasItems">
        <b-col>
          <b-alert show variant="primary" style="white-space:pre;">Your order will be shipped to:
  {{ShippingAddressInfo}}</b-alert>
        </b-col>
      </b-row>
        <b-row v-if="!CartHasItems">
            <b-col>
                <b-alert show variant="info"> Your Cart is empty.</b-alert>
            </b-col>
        </b-row>
        <b-row v-else>
            <b-col >
                <b-table class="not-mobile" striped hover :items="Items" :fields="CartFields">
                  <template #cell(ItemNumber)="data">
                        <b-link :to="{ name: 'ProductDetail', query: { number: data.item.ItemNumber }}">{{data.item.ItemNumber}}</b-link>
                    </template>
                    <template #cell(Name)="data">
                        <span>{{ data.item.Name }}</span>
                    </template>
                    <template #cell(UnitPrice)="data">
                        <span>${{ (data.item.Price).toFixed(2) }}</span>
                    </template>
                    <template #cell(ShopMoq)="data">
                      <span>{{data.item.QuantityMin || 1}}</span>
                    </template>
                    <template #cell(Carton)="data">
                      <span>{{data.item.CartonQuantity || 1}}</span>
                    </template>
                    <template #cell(Quantity)="data">
                        <div> 
                            <b-form-input :state="data.item.Qty > 0 ? ProductQtyValid(data.item) : null" :id="`QtyInput${data.index}`" type="number" :value="data.item.Qty" @input="(val) => UpdateLineQty(data.item, val)"/>
                            <b-form-text v-if="!ProductMeetsMin(data.item)">Minimum order quantity is {{data.item.QuantityMin}}</b-form-text>
                            <b-form-text v-if="!ProductMeetsStepSize(data.item)">Must order in multiples of {{data.item.QuantityStepSize}}</b-form-text>
                            <b-form-text v-if="!ProductMeetsMax(data.item)">Maximum order quantity is {{data.item.QuantityMax}}</b-form-text>
                        </div>
                    </template>
                    <template #cell(SubTotal)="data">
                      <span>${{ (data.item.Price * data.item.Qty * data.item.CartonQuantity).toFixed(2) }}</span>
                    </template>
                    <template #cell(actions)="data">
                        <b-btn variant="danger" v-on:click="removeFromCart(data.item)">Remove</b-btn>
                    </template>
                </b-table>
                <b-table class="mobile" striped :items="Items" :fields="mobileCartFields">
                  
                  <template #cell(Item)="data">
                    <b-link :to="{ name: 'ProductDetail', query: { number: data.item.ItemNumber }}">{{data.item.ItemNumber}}</b-link>
                    <div class="small">
                      {{ data.item.Name }}
                      <div v-if="ShowPrices">Unit: ${{ (data.item.Price).toFixed(2) }}</div>
                      <div v-if="data.item.QuantityMin">Min Order: {{data.item.QuantityMin}}</div>
                      <div>Ctn Qty: {{data.item.CartonQuantity || 1}}</div>
                      <div v-if="ShowPrices">Ctn: ${{ (data.item.Price).toFixed(2) * (data.item.CartonQuantity || 1) }}</div>
                    </div>
                  </template>
                  <template #cell(Quantity)="data">
                    <div> 
                      <b-form-input :state="data.item.Qty > 0 ? ProductQtyValid(data.item) : null" :id="`QtyInput${data.index}`" type="number" :value="data.item.Qty" @input="(val) => UpdateLineQty(data.item, val)"/>
                      <b-form-text v-if="!ProductMeetsMin(data.item)">Minimum order quantity is {{data.item.QuantityMin}}</b-form-text>
                      <b-form-text v-if="!ProductMeetsStepSize(data.item)">Must order in multiples of {{data.item.QuantityStepSize}}</b-form-text>
                      <b-form-text v-if="!ProductMeetsMax(data.item)">Maximum order quantity is {{data.item.QuantityMax}}</b-form-text>
                    </div>
                  </template>
                  <template #cell(SubTotal)="data">
                    <span>${{ (data.item.Price * data.item.Qty * data.item.CartonQuantity).toFixed(2) }}</span>
                  </template>
                  <template #cell(actions)="data">
                    <b-btn variant="danger" v-on:click="removeFromCart(data.item)"><i class="fa fa-times" aria-hidden="true" /></b-btn>
                  </template>
                </b-table>
                <b-row v-if="ShowPrices" class="total-row">
                  <div>Total Excluding Freight &amp; GST: ${{CartTotal}}</div>
                </b-row>
              <b-row>
                <b-col>
                  <b-btn variant="danger" v-on:click="EmptyCart">Empty Cart</b-btn>
                </b-col>
                <b-col class="text-right">
                  <b-btn v-on:click="Checkout" variant="success" :disabled="!CanCheckout || isOrderSubmitting">Checkout</b-btn><br>
                  <!-- <span class="error" v-if="!CanCheckout">{{CheckoutInfo}}</span> -->
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" />
                <b-col cols="4">
                  <label>Promo Code</label>
                  <b-input v-model="promoCode" placeholder="Code" />
                </b-col>
              </b-row>

            </b-col>
        </b-row>
    </div>
</template>

<script>
import store from "@/store.js";
import CheckoutService from "../services/CheckoutService";
import _ from 'lodash';
import ShowPrices from '@/mixins/ShowPrices';

export default {
  name: "Cart",
  mixins: [ShowPrices],
  data() {
    return {
      buttonText: 'Submit Order',
      isOrderSubmitting: false,
    };
  },
  computed: {
    promoCode: {
      get() {
        return this.$store.state.checkout.code;
      },
      set(val) {
        this.$store.commit("SetCode", val);
      }
    },
    Items() {
      return this.$store.state.cart;
    },
    CanCheckout() { 
      return true;
      return !this.HasInvalidQty;
    },
    CheckoutInfo() {
      if(this.CanCheckout) {
        return "Checkout";
      }
      else {
        return "One or more items in your cart has an invalid quantity";
      }
    },
    ShippingAddressInfo() {
      //var mainAddr = store.state.auth.userInfo.Addresses.find(el => el.IsPrimaryShipping);
      debugger;
      var company = _.find(this.$store.state.auth.userInfo.Companies, i => i.Oid === this.$store.state.auth.company.Oid);

      var mainAddr = company.Addresses.find(el => el.Oid === (company.PrimaryShippingAddress && company.PrimaryShippingAddress.Oid));
      
      //if(!mainAddr && store.state.auth.userInfo.Addresses.length > 0) {
      if(!mainAddr && company.Addresses.length > 0) {
        //mainAddr = store.state.auth.userInfo.Addresses[0];
        mainAddr = company.Addresses[0];
      }
      if(mainAddr) {
        var finalString = '';
        if(mainAddr.Line1) {
          finalString += mainAddr.Line1;
        }
        if(mainAddr.Line2) {
          finalString += `, ${mainAddr.Line2}`;
        }
        if(mainAddr.Line3) {
          finalString += `, ${mainAddr.Line3}`;
        }
        if(mainAddr.City) {
          finalString += `, ${mainAddr.City}`;
        }
        if(mainAddr.State) {
          finalString += `, ${mainAddr.State}`;
        }
        if(mainAddr.Postcode) {
          finalString += ` ${mainAddr.Postcode}`;
        }
        if(mainAddr.Country) {
          finalString += ` ${mainAddr.Country}`;
        }
        
        return finalString.replace(/[, ]+$/, '').replace(/[, ]{3,}/g, ', ').replace(/, /g, '\n').trim();
      }
      else {
        return 'No Billing Address found';
      }
    },
    HasInvalidQty() {
      var invalidQtyItems = _.filter(this.Items, i => !this.ProductQtyValid(i));
      return invalidQtyItems.length > 0;
    },
    CartHasItems() {
      return this.$store.state.cart.length > 0;
    },
    CartTotal() {
        return this.$store.state.cart.reduce((total, item) => total + (item.Price * item.Qty * item.CartonQuantity), 0).toFixed(2);
    },
    CartFields() {

      var fields = [
        { key: 'ItemNumber'}, 
        { key: 'Name' },
        { key: 'ShopMoq', label: 'MOQ'},
        { key: 'Quantity', label: 'Boxes Required' },
        { key: 'Carton', label: 'Carton Size'},
        { key: 'actions', label: 'Actions'},
      ];

      if(this.ShowPrices) {
        fields.splice(3, 0, { key: 'UnitPrice', label: 'Unit Price' });
        fields.splice(6, 0, { key: 'SubTotal', label: 'Sub Total' });
      }

      return fields;      
    },
    mobileCartFields() {
      var fields = [
        {key: "Item"},
        {key: "Quantity", label: 'Qty'},
        {key: "actions", label: ""},
      ]

      if(this.ShowPrices) {
        fields.splice(2, 0, { key: 'SubTotal', label: 'Sub Total' });
      }
      return fields;
    }
  },
  beforeRouteEnter(to, from, next) {
    CheckoutService.UpdateCartPrices().then(() => {
      next();
    });
  },
  beforeRouteUpdate(to, from, next) {
    CheckoutService.UpdateCartPrices().then(() => {
      next();
    });
  },
  methods: {
    EmptyCart() {
      this.$store.commit("EmptyCart");
    },
    removeFromCart(product) {
        this.$store.commit("RemoveFromCart", product);
    },
    UpdateLineQty(line, newQty) {
        this.$store.commit("SetCartLineQuantity", { Product: line, Qty: newQty } );
    },
    Checkout() {
        CheckoutService.StartCheckoutProcess(this);
    },
    ProductMeetsMin(product){
      if(product.Qty > 0 && product.QuantityMin > 0) {
        return product.Qty >= product.QuantityMin;
      }
      return true;
    },
    ProductMeetsMax(product){
      if(product.Qty > 0 && product.QuantityMax > 0) {
        return product.Qty <= product.QuantityMax;
      }
      return true;
    },
    ProductMeetsStepSize(product){
      if(product.Qty > 0 && product.QuantityStepSize > 0) {
        return product.Qty % product.QuantityStepSize == 0;
      }
      return true;
    },
    ProductQtyValid(product) {
        if(product.Qty === null || product.Qty === undefined || product.Qty === "" || product.Qty <= 0) {
          return false;
        }
        if(!this.ProductMeetsMin(product) || 
          !this.ProductMeetsMax(product) || 
          !this.ProductMeetsStepSize(product)) {
            return false;
        }
        return true;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.card:hover {
  background: #f1f2f6;
  cursor: pointer;
}

.ActionRow {
    position: absolute;
    bottom: 0;
    right: 0;
}

.total-row {
  display: flex;
  justify-content: end;
  margin-left: auto;
  margin-right: 0px;
  font-size: 1.2em;
  font-weight: bold;
  padding-bottom: 15px;
}

.mobile {
  display: none;
}

.not-mobile {
  display: inherit;
}

@media screen and (max-width: 768px) {
  .mobile {
    display: block;
    font-size: 0.9em;
  }
  .not-mobile {
    display: none;
  }
}

.error {
  color: red;
  font-size: 0.8em;
}

</style>



// WEBPACK FOOTER //
// src/components/cart.vue